import { head, last, get, isUndefined, pick } from 'lodash-es'
import axios from 'axios'

import { types as STORE_MODULES } from '@/js/plugins/store/store-modules.js'
import AIMEOS_GETTERS from '@/js/plugins/store/modules/aimeos/getter-types/index.js'
import AIMEOS_META_CONSTANTS from '@/js/helper/aimeos-meta-constants.js'

import { generateProductData } from '@/js/helper/product-data-helper.js'

export const getTypeParts = type => {
  const typeArray = type.split('.')
  const mainType = head(typeArray)
  const subType = last(typeArray)
  return {
    mainType,
    subType: subType === mainType ? undefined : subType,
  }
}

export const getAvailabilityProductData = async ({ sku, rootGetters } = {}) => {
  console.log('getAvailabilityProductData')

  const url = await rootGetters[
    `${STORE_MODULES.AIMEOS}/${AIMEOS_GETTERS.GET_OPTIONS_PROMISE_URL}`
  ](AIMEOS_META_CONSTANTS.PATHS.SKU).catch(e => console.log(e))

  if (isUndefined(url)) {
    return []
  }

  const codes = Array.isArray(sku) ? sku.join(',') : sku

  const params =
    codes.length > 500
      ? {
          method: 'POST',
          url: `${url}${
            /\?/.test(url) ? '&' : '?'
          }ai%5Binclude%5D=media%2Cprice%2Ctext%2Cattribute%2Cproduct%2Fproperty`,
          data: { data: { sku: codes } },
        }
      : {
          method: 'GET',
          url: `${url}${
            /\?/.test(url) ? '&' : '?'
          }ai%5Binclude%5D=media%2Cprice%2Ctext%2Cattribute%2Cproduct%2Fproperty&ai%5Bsku%5D=${codes}`,
        }

  const response = await axios(params).catch(() => {
    return []
  })

  const transformedData = generateProductData({
    apiData: get(response, 'data', {}),
    // rootGetters,
    variantDetailData: true,
  })

  return get(transformedData, 'data', []).map(product =>
    pick(product, [
      'name',
      'code',
      'parentName',
      'parentId',
      'productId',
      'productScope',
      'isSparepartArticleType',
      'isSparePart',
      'allowedBasketPost',
      'basketLinkUrl',
      'customBasketAttributes',
      // tagManager
      'firstPrice',
      'firstPriceCurrency',
      'brand',
      'productBidexCode',
      'groupPrices',
      'hasSoldOutSelling',
      'archiveItem',
      'articleType',
    ]),
  )
}
